import Lookup from 'src/componentes/select2';

const StatusApresentacao = ({ clearable = true, ...props }) => {
  return (
    <Lookup
      clearable={clearable}
      labelKey="descricao"
      valueKey="id"
      url="/StatusApresentacaoLookup"
      {...props}
    />
  );
};

export default StatusApresentacao;
